import React, { useState } from "react";
import "./deviceInfo.css";
import useDeviceInfo from "../hooks/useDeviceInfo";

const DeviceInfo = ({ onInfoUpdate }) => {
  const {
    ip,
    localIP,
    ipInfo,
    browserLocation,
    deviceDetails,
    loading,
    error,
    refreshInfo,
  } = useDeviceInfo();

  const [isExpanded, setIsExpanded] = useState(false);

  // Notificar cambios a componente padre si se proporciona callback
  React.useEffect(() => {
    
    if (loading) return;

    const fullInfo = {
      ip,
      localIP,
      ipInfo,
      browserLocation,
      deviceDetails,
      ubicacionTexto: ipInfo
        ? `${ipInfo.city}, ${ipInfo.region}, ${ipInfo.country}`
        : "",
      plataforma: deviceDetails?.platform ?? "",
      estado: deviceDetails?.onLine ? "Conectado" : "Desconectado",
    };

    // Notificar al padre si mandaste callback
    if (onInfoUpdate) {
      onInfoUpdate(fullInfo);
    }

    // Guardar también en localStorage
    localStorage.setItem("deviceInfo", JSON.stringify(fullInfo));
  }, [
    ip,
    localIP,
    ipInfo,
    browserLocation,
    deviceDetails,
    loading,
    onInfoUpdate,
  ]);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  if (loading) {
    return (
      <div className="device-info-loading">
        <div className="loading-spinner-small"></div>
        <span>Obteniendo información del dispositivo...</span>
      </div>
    );
  }

  return (
    <div className="device-info-container">
      <div className="device-info-header" onClick={toggleExpanded}>
        <span className="device-info-title">
          📍 Información del Dispositivo
        </span>
        <span className={`device-info-toggle ${isExpanded ? "expanded" : ""}`}>
          ▼
        </span>
      </div>

      {isExpanded && (
        <div className="device-info-content">
          {error && (
            <div className="device-info-error">
              <span>⚠️ {error}</span>
              <button onClick={refreshInfo} className="refresh-btn">
                🔄 Reintentar
              </button>
            </div>
          )}

          {/* Información de IP */}
          <div className="info-section">
            <h4>🌐 Información de Red</h4>
            <div className="info-grid">
              <div className="info-item ip-public">
                <strong>IP Pública:</strong> {ip || "No disponible"}
              </div>
              <div className="info-item ip-local">
                <strong>IP Local:</strong> {localIP || "No disponible"}
              </div>
              {ipInfo && (
                <>
                  <div className="info-item">
                    <strong>Ubicación:</strong> {ipInfo.city}, {ipInfo.region},{" "}
                    {ipInfo.country}
                  </div>
                  <div className="info-item">
                    <strong>Proveedor:</strong> {ipInfo.isp}
                  </div>
                  <div className="info-item">
                    <strong>Zona Horaria:</strong> {ipInfo.timezone}
                  </div>
                  <div className="info-item">
                    <strong>Coordenadas (IP):</strong> {ipInfo.latitude},{" "}
                    {ipInfo.longitude}
                  </div>
                </>
              )}
              <div className="info-item">
                <strong>Estado:</strong>{" "}
                {deviceDetails?.onLine ? "🟢 Conectado" : "🔴 Desconectado"}
              </div>
            </div>
          </div>

          {/* Geolocalización del navegador */}
          {browserLocation && (
            <div className="info-section">
              <h4>📱 Geolocalización Precisa</h4>
              <div className="info-grid">
                <div className="info-item">
                  <strong>Latitud:</strong>{" "}
                  {browserLocation.latitude.toFixed(7)}
                </div>
                <div className="info-item">
                  <strong>Longitud:</strong>{" "}
                  {browserLocation.longitude.toFixed(7)}
                </div>
                <div className="info-item">
                  <strong>Precisión:</strong> ±
                  {Math.round(browserLocation.accuracy)}m
                </div>
                <div className="info-item">
                  <strong>Timestamp:</strong>{" "}
                  {new Date(browserLocation.timestamp).toLocaleString()}
                </div>
              </div>
            </div>
          )}

          {/* Información del dispositivo */}
          <div className="info-section">
            <h4>💻 Información del Dispositivo</h4>
            <div className="info-grid">
              <div className="info-item">
                <strong>Plataforma:</strong> {deviceDetails?.platform}
              </div>
              <div className="info-item">
                <strong>Idioma:</strong> {deviceDetails?.language}
              </div>
              <div className="info-item">
                <strong>Pantalla:</strong> {deviceDetails?.screenWidth}x
                {deviceDetails?.screenHeight}
              </div>
              <div className="info-item">
                <strong>Ventana:</strong> {deviceDetails?.windowWidth}x
                {deviceDetails?.windowHeight}
              </div>
              <div className="info-item">
                <strong>Zona Horaria:</strong> {deviceDetails?.timezone}
              </div>
              <div className="info-item">
                <strong>Cookies:</strong>{" "}
                {deviceDetails?.cookieEnabled ? "✅" : "❌"}
              </div>
            </div>
          </div>

          {/* Navegador */}
          <div className="info-section">
            <h4>🌐 Navegador</h4>
            <div className="info-item">
              <strong>User Agent:</strong>
              <div className="user-agent-text">{deviceDetails?.userAgent}</div>
            </div>
          </div>

          <div className="device-info-actions">
            <button onClick={refreshInfo} className="refresh-btn">
              🔄 Actualizar Información
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeviceInfo;
